import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import React, { useState,useEffect } from "react";
import { Formik } from 'formik';
import { toast } from "react-toastify";
import ErrorMessage from "../components/ErrorMessage";
import { NoAuthApiRequest,ApiRequest } from "./services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";
import { useNavigate } from "react-router";
import { addClient } from "../utils/schema";
import { Tooltip } from 'react-tooltip'
import Select from 'react-select';


const AssignUser = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate();
         const [currentPage, setCurrentPage] = useState(1);
         const [pageSize, setPageSize] = useState(100); // Default page size
         const [totalPages, setTotalPages] = useState(0);
    
         const [startCount, setstartCount] = useState("");
         const [endCount, setendCount] = useState("");
         const [totalCount, settotalCount] = useState("");

         const [LeadOption,setLeadOption]=useState([]);
         const [UserOption,setUserOption]=useState([]);

         //const [lstClient,setlstClient]=useState([]);
    
         const [lstUser,setlstUser]=useState([]);
        const [lstProject, setlstProject] =useState([]);
    
            const [formData, setFormData] = useState({
                ProjectId: '',
                LeadId: [],
                UserId:[],
                Id:0,
                UserId:-1,
            });
    
            const handleChange = (e) => {
                const { name, value } = e.target;
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
            };

             useEffect(() => {
                 const fetchData = async () => {
                               await FetchProjects();
                               await FetchUserWithRole();
                            };
                            fetchData();
                    
                        },[]);

             const FetchProjects = async () => {
                    const data = await ApiRequest(
                        ApiEndpoints.Entity.FetchProject,
                        ApiEndpointMethod.Get,
                        null,
                        navigate
                      );
                      setlstProject(data);
                };

                
             const FetchUserWithRole = async () => {
                const data = await ApiRequest(
                    ApiEndpoints.Entity.FetchUserWithRole,
                    ApiEndpointMethod.Get,
                    null,
                    navigate
                  );
                  setlstUser(data);
                 var adminusers = data.filter(x=>x.Role=="Admin"|| x.Role=="Lead").flatMap(role => role.Users);
                 setLeadOption(adminusers);
                
                 var employeeUser = data.filter(x=>x.Role=="Employee").flatMap(role => role.Users);
                 setUserOption(employeeUser);
            };

            const CreateProjectUserAssignment = async (validateForm, setTouched, values) => {

            };
          

    
    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Assign Users</h5>
                            <div className="d-flex align-items-center">
                                <input className="form-control me-2" placeholder="search..." type="search" style={{ width: '220px' }} />
                                <button className="btn btn-sm btn-info" data-bs-toggle="modal"
                                    data-bs-target="#assignUser">
                                    <i className="fas fa-plus me-1"></i>Assign User
                                </button>
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table className="table table-striped table-bordered bg-white mb-0">
                                <thead>
                                    <tr>
                                        <th width="15%">Project Name</th>
                                        <th width="15%">Manager</th>
                                        <th width="15%">Team Lead</th>
                                        <th width="15%">Designer</th>
                                        <th width="15%">Developer</th>
                                        <th width="15%">Tester</th>
                                        <th width="10%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Amalga</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Rachel
                                            </div>
                                        </td>
                                        <td>-</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Preethi R
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Madhumitha R
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Revathy
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Novafai</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Rachel
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Harini Swamy
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Preethi R
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center mb-1">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Vinothkumar
                                            </div>
                                            <div className="d-flex align-items-center mb-1">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Manikandan
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Raja Priya V
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <img src="assets/images/Felicity_Smoak.jpg" height="18px" className="rounded-pill me-1" />
                                                Revathy
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="assignUser" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Assign User</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        
                          <Formik
                                                                                    enableReinitialize={true}
                                                                                    initialValues={formData}
                                                                                    // validationSchema={addProject()}
                                                                                    onSubmit={(values, actions) => {
                                                                                        CreateProjectUserAssignment(values);
                                                                                    }}
                                                                                >
                                                                                    {({
                                                                                        values,
                                                                                        errors,
                                                                                        touched,
                                                                                        handleChange1,
                                                                                        handleBlur,
                                                                                        handleSubmit,
                                                                                        setFieldValue,
                                                                                        setTouched,
                                                                                        validateForm,
                                                                                    }) => (
                                                                                        <form>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Project Name<span className="text-danger">*</span></label>
                                {/* <input className="form-control" type="text" /> */}
                                <select className="form-control"
                                value={values?.ProjectId}
                                name="ProjectId"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                >
                                        <option value="0">--select--</option>
                                        {lstProject?.map((project) => (
                                              <option value={project.Id}>
                                        {project.Name}
                                  </option>
                                ))}
                                </select>
                            </div>
                            {/* <div className="form-group">
                                <label>Manager</label>
                                <div class="dropdown">
                                    <input className="form-control" data-bs-toggle="dropdown" aria-expanded="false" />
                                    <ul class="dropdown-menu w-100">
                                        <li><a class="dropdown-item" href="#">Rachel</a></li>
                                        <li><a class="dropdown-item" href="#">Harini Swamy</a></li>
                                        <li><a class="dropdown-item" href="#">Preethi R</a></li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="form-group">
                                <label>Team Lead</label>
                                <div class="dropdown">
                                    <select>

                                    </select>
                                    {/* <input className="form-control" data-bs-toggle="dropdown" aria-expanded="false" />
                                    <ul class="dropdown-menu w-100">
                                        <li><a class="dropdown-item" href="#">Rachel</a></li>
                                        <li><a class="dropdown-item" href="#">Harini Swamy</a></li>
                                        <li><a class="dropdown-item" href="#">Preethi R</a></li>
                                    </ul> */}
                                </div>
                            </div>
                            {/* <div className="form-group">
                                <label>Designer</label>
                                <div class="dropdown">
                                    <input className="form-control" data-bs-toggle="dropdown" aria-expanded="false" />
                                    <ul class="dropdown-menu w-100">
                                        <li><a class="dropdown-item" href="#">Rachel</a></li>
                                        <li><a class="dropdown-item" href="#">Harini Swamy</a></li>
                                        <li><a class="dropdown-item" href="#">Preethi R</a></li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="form-group">
                                <label>Developer</label>
                                <div class="dropdown">
                                    <input className="form-control" data-bs-toggle="dropdown" aria-expanded="false" />
                                    <ul class="dropdown-menu w-100">
                                        <li><a class="dropdown-item" href="#">Rachel</a></li>
                                        <li><a class="dropdown-item" href="#">Harini Swamy</a></li>
                                        <li><a class="dropdown-item" href="#">Preethi R</a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* <div className="form-group">
                                <label>Tester</label>
                                <div class="dropdown">
                                    <input className="form-control" data-bs-toggle="dropdown" aria-expanded="false" />
                                    <ul class="dropdown-menu w-100">
                                        <li><a class="dropdown-item" href="#">Rachel</a></li>
                                        <li><a class="dropdown-item" href="#">Harini Swamy</a></li>
                                        <li><a class="dropdown-item" href="#">Preethi R</a></li>
                                    </ul>
                                </div>
                            </div> */}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-sm btn-outline-info me-2" data-bs-dismiss="modal">
                                <i className="fas fa-times me-2"></i>Cancel
                            </button>
                            <button type="button" className="btn btn-sm btn-info" data-bs-dismiss="modal">
                                <i className="fas fa-check me-2"></i>Save
                            </button>
                        </div>
 </form>
                             )}
                             </Formik>
                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
        </>
    )
}

export default AssignUser;